import { memo } from 'react';
import { IvrEvent } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import { Trans, useTranslation } from '@frontend/i18n';
import { DotRow, formatTime } from '../../utils/get-event-accordion-body';

export const IVREvent = memo(
  ({ dtmfEvents, callerName }: { dtmfEvents?: IvrEvent['dtmfEvents']; callerName?: string }) => {
    const { t } = useTranslation('calls');
    return (
      <>
        {dtmfEvents?.map((dtmf, idx) => (
          <DotRow
            key={dtmf.key}
            message={
              <Trans t={t}>
                {callerName} dials <strong>Option {dtmf.key}</strong>
              </Trans>
            }
            time={formatTime(dtmf.createdAt)}
            isLast={idx === (dtmfEvents?.length ?? 0) - 1}
          />
        ))}
      </>
    );
  }
);

IVREvent.displayName = 'IVREvent';
